import { render, staticRenderFns } from "./ConstructionEdit.vue?vue&type=template&id=7c9f4d53&scoped=true&"
import script from "./ConstructionEdit.vue?vue&type=script&lang=ts&"
export * from "./ConstructionEdit.vue?vue&type=script&lang=ts&"
import style0 from "./ConstructionEdit.vue?vue&type=style&index=0&id=7c9f4d53&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c9f4d53",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VMain } from 'vuetify/lib/components/VMain';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VMain,VRow})
